'use client'

import Link from 'next/link'

import { AHeaderOrderOnlineZLink } from '../a-header-order-online-z-link'

interface AMobileHeaderTopProps {
	onLinkClick: () => void
	isVisible?: boolean
	menuOpen?: boolean
}

export const AMobileHeaderTop = ({
	onLinkClick,
	isVisible = true,
	menuOpen = false
}: AMobileHeaderTopProps) => {
	return (
		<div
			className={`header-mobile__top show_lgm ${
				!isVisible ? 'header-mobile__top--hidden' : ''
			} ${menuOpen ? 'header-mobile__top--menu-open' : ''}`}
		>
			<div className='header-mobile__contact'>
				<Link
					href='tel:+421220302303'
					prefetch={false}
					title='Tel. č.: +421 2 20 302 303'
					className='header-mobile__phone-section'
				>
					<div className='header-mobile__icon'>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							viewBox='0 0 24 24'
							fill='currentColor'
						>
							<path
								fillRule='evenodd'
								d='M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z'
								clipRule='evenodd'
							/>
						</svg>
					</div>
					<div className='header-mobile__number'>
						<span className='header-mobile__number-label'>Klientske centrum</span>
						<span className='header-mobile__number-value'>
							+421&nbsp;2&nbsp;20&nbsp;302&nbsp;303
						</span>
					</div>
				</Link>

				<AHeaderOrderOnlineZLink
					href='/volne-terminy'
					title='Objednajte sa'
					className='btn_basic type4 header_order mobile_order_btn'
					onClick={onLinkClick}
					prefetch={true}
				>
					<span>Objednať sa online</span>
					<span className='inline-block min-w-[22px]'>
						<span>
							<svg className='sico'>
								<use href='/assets/layout/icons.svg#s_ar3_r' />
							</svg>
						</span>
						<span>
							<svg className='sico'>
								<use href='/assets/layout/icons.svg#s_ar3_r' />
							</svg>
						</span>
					</span>
				</AHeaderOrderOnlineZLink>
			</div>
		</div>
	)
}
